import styled from 'styled-components';


const StyledStatsOffice = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 12px;
`;

export default StyledStatsOffice;
